import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Bestselling = () => {
  const [sarees, setSarees] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch("https://prsilks.com/proxy.php")
      .then((res) => res.json())
      .then((data) => {
        const filtered = data.filter(
          (item) =>
            item.section &&
            item.section.toLowerCase() === "best selling"
        );
        setSarees(filtered);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        setSarees([]);
      });
  }, []);

  const handleClick = (subcategory) => {
    navigate(`/subcategory/${encodeURIComponent(subcategory)}`);
  };

  return (
    <div className="mt-9 mb-5">
       <h2 className="font-abhaya text-lg md:text-2xl 4xl:text-4xl 8xl:text-5xl 10xl:text-6xl text-center font-bold text-secondary tracking-wider mb-6">
        P.R Silks Special
      </h2>
  <div className="overflow-x-auto 3xl:overflow-visible scrollbar-hide">
        <div className="flex gap-6 px-6 snap-x snap-mandatory scroll-pl-10 3xl:grid 3xl:grid-cols-3 3xl:gap-10 7xl:px-24">
          {sarees.map((item, index) => (
            <div
              key={index}
              onClick={() => handleClick(item.subcategory)}
              className="snap-center relative flex-shrink-0 w-[70%] sm:w-[55%] md:w-[45%] lg:w-[35%] 3xl:w-auto flex flex-col items-center transition-all duration-300 ease-in-out hover:scale-105"
            >
              <div className="rounded-2xl overflow-hidden shadow-lg">
                <img
                  src={item.url}
                  alt={item.name}
                  className="w-full h-auto object-cover"
                  loading="lazy"
                />
              </div>
             <p className="text-center mt-4 font-bellefair text-[12px] xs:text-[16px] md:text-[23px] 3xl:text-xl 7xl:text-2xl 9xl:text-3xl 10xl:text-5xl 11xl:text-7xl  ">
              {item.subcategory}
            </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Bestselling;
